// /src/store/reducers/billingReducer.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchUsages } from "../actions/billingActions";

const initialState = {
  usages: [],
  accountType: "business", // of 'personal'
  companyInfo: {
    companyName: "",
    address: " ",
    regNr: "",
    vatNr: "",
    city: "",
    areaCode: "",
    emailAddress: "",
  },
  loading: false,
  error: null,
};

const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setUsages(state, action) {
      state.usages = action.payload;
    },
    setAccountType(state, action) {
      state.accountType = action.payload;
    },
    setCompanyInfo(state, action) {
      state.companyInfo = { ...state.companyInfo, ...action.payload };
    },
    resetBilling(state, action){
      state.companyInfo = initialState.companyInfo;
      state.accountType = initialState.accountType;
      state.usages = initialState.usages;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsages.fulfilled, (state, action) => {
        state.loading = false;
        state.usages = action.payload;
      })
      .addCase(fetchUsages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setUsages, setAccountType, setCompanyInfo, resetBilling } =
  billingSlice.actions;
export default billingSlice.reducer;
